import { Logger, engineComponent } from "neo-common";
import { Song } from "./Song";
import { ComponentTypes } from "../ComponentTypes";
import { SoundManager } from "../Managers/SoundManager";

@engineComponent(ComponentTypes.PlayList)
export class PlayList {
    static Songs: { [id: string]: Song } = {};

    static addToPlayList(song: Song): void {
        PlayList.Songs[song.id] = song;
    }

    create(node: Element): void {
        SoundManager.parseElements(node, node.nodeName);
    }

    static isPlaying(song: string): boolean {
        if (PlayList.Songs[song] != null) {
            return PlayList.Songs[song].isPlaying();
        }
    }

    static play(song: string, fadeIn: number = 0, reset: boolean = true): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].play(false, fadeIn, reset);
        }
    }

    static loop(song: string, fadeIn: number = 0, reset: boolean = false): Song {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].play(true, fadeIn, reset);

            return PlayList.Songs[song];
        }
        return null;
    }

    static stop(song: string, fadeOut: number = 0): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].stop(fadeOut);
        }
    }

    static stopAll(fadeOut: number = 0): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                PlayList.Songs[song].stop(fadeOut);
            }
        }
    }

    static stopAllInGroup(group: string, toggle: boolean = false): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                PlayList.Songs[song].toggleGroup(group, toggle);
            }
        }
    }

    static pauseAll(): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                PlayList.Songs[song].pause();
            }
        }
    }
    static resumeAll(): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                PlayList.Songs[song].resume();
            }
        }
    }

    /**
     * Set volume level with possibility to fade in or fade out the song.
     * @param song
     * @param volume
     * @param fadeDuration When target volume is bigger than current volume, make fade in. Else make fade out.
     */
    static setVolume(song: string, volume: number, fadeDuration?: number): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].setVolume(volume, fadeDuration);
        }
    }

    /**
     * Re-set volume level with possibility to fade in or fade out the song.
     * @param song
     * @param fadeDuration When target volume is bigger than current volume, make fade in. Else make fade out.
     */
    static resetVolume(song: string, fadeDuration?: number): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].resetVolume(fadeDuration);
        }
    }

    static log(s: string): void {
        if (DEBUG) {
            const compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Sounds/PlayList.ts
 **/